import { getFeature, isFeature } from 'Cloud/Application/FeaturesEs6';

export const DISABLE_LOGO_CLICK_ATTACH_VIEWER = isFeature('disable-attach-vw-logo-click');

export const IGNORE_LINK_INTERCEPT_FOR_B2C_SUPERAPP: string[] = getFeature('ignore-link-intercept-b2c-superapp') || [
    '/promo/desktop',
    '/files_migration',
];
